var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPhoto = function SvgPhoto(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7933 22.9493C25.9936 21.4023 24.379 20.3448 22.5174 20.3448C19.8607 20.3448 17.707 22.4985 17.707 25.1552C17.707 27.8119 19.8607 29.9656 22.5174 29.9656C23.3125 29.9656 24.0626 29.7727 24.7233 29.4311",
    className: "highlight",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 39.0001V37.4671C14.5 33.3241 18.0895 29.9656 22.5173 29.9656C23.2847 29.9656 24.027 30.0665 24.7298 30.2549C24.9102 30.3032 25.0881 30.3574 25.263 30.4171",
    className: "highlight",
    strokeWidth: 1.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0488 23.2859C31.7783 21.5578 33.4888 20.3448 35.4825 20.3448C38.1392 20.3448 40.2928 22.4985 40.2928 25.1552C40.2928 27.8119 38.1392 29.9656 35.4825 29.9656C34.6584 29.9656 33.8827 29.7583 33.2046 29.3931",
    className: "highlight",
    strokeWidth: 1.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4997 39.0001V37.4671C43.4997 33.3241 39.9103 29.9656 35.4825 29.9656C34.6159 29.9656 33.7814 30.0942 32.9996 30.3322C32.9032 30.3616 32.8076 30.3926 32.7129 30.4252",
    className: "highlight",
    strokeWidth: 1.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8102 27.2931C33.8102 29.9498 31.6565 32.1035 28.9998 32.1035C26.3431 32.1035 24.1895 29.9498 24.1895 27.2931C24.1895 24.6365 26.3431 22.4828 28.9998 22.4828C31.6565 22.4828 33.8102 24.6365 33.8102 27.2931Z",
    stroke: "currentColor",
    strokeWidth: 1.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.017 39.6051C37.017 35.4621 33.4275 32.1035 28.9997 32.1035C24.5719 32.1035 20.9824 35.4621 20.9824 39.6051",
    stroke: "currentColor",
    strokeWidth: 1.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 14C13.4 13.3925 13.8925 12.9 14.5 12.9H43.5C44.1075 12.9 44.6 13.3925 44.6 14V38C44.6 38.6075 44.1075 39.1 43.5 39.1H14.5C13.8925 39.1 13.4 38.6075 13.4 38V14Z",
    stroke: "currentColor",
    strokeWidth: 1.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 9C8.9 8.39249 9.39249 7.9 10 7.9H49C49.6075 7.9 50.1 8.39249 50.1 9V51C50.1 51.6075 49.6075 52.1 49 52.1H10C9.39249 52.1 8.9 51.6075 8.9 51V9Z",
    stroke: "currentColor",
    strokeWidth: 1.8
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPhoto);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/svg-icons/photo.svg";